<template>
  <div class="columns">
    <div class="column">
      <b-field
        placeholder="First name"
        label="First Name"
        custom-class="is-small"
      >
        <div class="level">
          <input
            @focus="$event.target.select()"
            class="input"
            v-model="firstName"
            type="text"
          >
        </div>
      </b-field>
      <b-field
        placeholder="Last name"
        label="Last Name"
        custom-class="is-small"
      >
        <div class="level">
          <input
            @focus="$event.target.select()"
            class="input"
            v-model="lastName"
            type="text"
          >
        </div>
      </b-field>
      <div class="level">
        <div class="level-left">
          <div class="level-item">
            <button
              class="button is-primary"
              v-on:click="saveChanges()"
            >Save Changes</button>
          </div>
        </div>
      </div>
    </div>
    <div class="column">
      <b-field
        placeholder="Email"
        label="Email"
        custom-class="is-small"
      >
        <div class="level">
          <input
            @focus="$event.target.select()"
            class="input"
            v-model="email"
            type="text"
          >
        </div>
      </b-field>
      <b-field
        placeholder="Password"
        label="Password (leave blank for no change)"
        custom-class="is-small"
      >
        <b-input
          @focus="$event.target.select()"
          type="password"
          v-model="password"
          password-reveal
        />
      </b-field>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      email: "",
      password: "",
      firstName: "",
      lastName: ""
    };
  },
  methods: {
    saveChanges() {
      console.log(
        "saveChanges()",
        this.$store.getters.session.user.id,
        this.email,
        this.password,
        this.firstName,
        this.lastName
      );
      var user = {
        id: this.$store.getters.session.user.id,
        email: this.email,
        password: this.password,
        firstName: this.firstName,
        lastName: this.lastName
      };
      this.$store.dispatch("updateUser", user);
      this.$buefy.toast.open({
        message: `Changes saved`,
        type: "is-success",
        duration: 3000
      });
    }
  },
  mounted() {
    this.email = this.$store.getters.session.user.email;
    this.firstName = this.$store.getters.session.user.firstName;
    this.lastName = this.$store.getters.session.user.lastName;
    this.password = "";
  }
};
</script>

<style>
</style>
